
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wiki/[slug]/events",
      function () {
        return require("private-next-pages/wiki/[slug]/events.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wiki/[slug]/events"])
      });
    }
  